
import React, { useState } from 'react'


import FIImg from "../../assets/FI.jpg";
import SEO from '../SEO';
import Header from './Header';
import Footer from './Footer';

const FibonacciRetracement = () => {
    const [language, setLanguage] = useState("english")
    return (

        <div className=" w-screen h-full">

            <Header></Header>

            <div className="bg-white/10 backdrop-blur-md m-3 rounded-lg">
                <div className="  px-4 py-5 bg-white/20  ">
                    {/* Hero Image */}
                    <div className="rounded-xl flex justify-center   overflow-hidden shadow-lg">
                        <img
                            src={FIImg}
                            alt="SMA Indicator"
                            className="object-cover h-72 w-full "
                        />
                    </div>

                    {/* Category Tag */}
                    <div className="mt-6">
                        <span className="inline-block bg-indigo-600 text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide">
                            Technical Indicator
                        </span>
                    </div>



                    <div className="w-full  rounded-md p-4 mt-2  flex flex-col items-center justify-between">




                        <h1 className="text-3xl sm:text-4xl font-bold text-black mt-4 leading-tight">
                            Understanding the Fibonacci Retracement Indicator
                        </h1>



                        <div className="flex flex-wrap m-4 gap-3">
                            <button
                                onClick={() => setLanguage("english")}
                                className={`p-2 font-bold rounded-md ${language === "english"
                                    ? "bg-blue-500 text-white"
                                    : "bg-blue-200 text-black"
                                    }`}
                            >
                                English
                            </button>

                            <button
                                onClick={() => setLanguage("hindi")}
                                className={`p-2 font-bold rounded-md ${language === "hindi"
                                    ? "bg-blue-500 text-white"
                                    : "bg-blue-200 text-black"
                                    }`}
                            >
                                हिन्दी
                            </button>
                        </div>


                        {language === "english" && (
                            <div>
                                <p className="mt-6 text-black leading-relaxed">
                                    Fibonacci Retracement is a popular technical analysis tool used to identify potential support and resistance levels during price corrections or pullbacks. Based on key Fibonacci ratios (such as 23.6%, 38.2%, 50%, 61.8%, and 78.6%), it helps traders anticipate where price may pause or reverse. Understanding F
                                </p>

                                <div className="w-full">
                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        How to Use Fibonacci Retracement in Trading
                                    </h2>

                                    <ol className="list-decimal ml-6 mt-4 space-y-4 text-black">
                                        <li>
                                            <strong>Open Your Trading Platform:</strong> Log in to your charting platform (like TradingView or Zerodha) where you can draw tools on price charts.
                                        </li>

                                        <li>
                                            <strong>Select a Clear Trend:</strong> Identify a strong price trend
                                            (either upward or downward). Fibonacci works best after a big move.
                                        </li>

                                        <li>
                                            <strong>Choose the Fibonacci Retracement Tool:</strong> Click on the
                                            <em>Fibonacci Retracement</em> tool from the chart's drawing tools.
                                        </li>

                                        <li>
                                            <strong>Draw from Swing Low to Swing High:</strong>
                                            - In an **uptrend**, drag from the **lowest point (swing low)** to the **highest point (swing high)**.
                                            - In a **downtrend**, drag from the **swing high to swing low**.
                                        </li>

                                        <li>
                                            <strong>Observe the Key Fibonacci Levels:</strong> Levels like
                                            <code>23.6%</code>, <code>38.2%</code>, <code>50%</code>, <code>61.8%</code>, and <code>78.6%</code> will appear automatically.
                                            These are potential support (in an uptrend) or resistance (in a downtrend) zones.
                                        </li>

                                        <li>
                                            <strong>Plan Your Trade:</strong>
                                            Watch how price reacts around these levels:
                                            <br />- If price bounces up from a Fib level → it may act as **support**.
                                            <br />- If price falls from a Fib level → it may act as **resistance**.
                                        </li>

                                        <li>
                                            <strong>Confirm with Other Indicators:</strong> Combine Fibonacci levels
                                            with indicators like RSI, MACD, or candlestick patterns to confirm signals.
                                        </li>
                                    </ol>


                                    <ul className="list-disc ml-6 mt-4 space-y-2 text-black">
                                        <li>
                                            <strong> Pros:</strong>
                                            <br />- Helps identify potential support and resistance zones.
                                            <br />- Works well with trend continuation or reversal analysis.
                                            <br />- Can be combined with other indicators for stronger signals.
                                            <br />- Useful for planning entry, exit, and stop loss levels.
                                        </li>

                                        <li>
                                            <strong> Cons:</strong>
                                            <br />- Does not predict direction — only possible levels.
                                            <br />- Subjective: depends on which high/low points are chosen.
                                            <br />- Not reliable in very volatile or news-driven markets.
                                            <br />- Works best when used with other confirmation indicators.
                                        </li>
                                    </ul>


                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        What Fibonacci Retracement Can Exactly Do
                                    </h2>

                                    <ol className="list-disc pl-5 space-y-2 text-black">
                                        <li>
                                            <strong>Identify Potential Support and Resistance Levels:</strong> Fibonacci retracement levels highlight key price areas where a trend might pause or reverse.
                                        </li>
                                        <li>
                                            <strong>Measure Pullback Levels in a Trend:</strong> Helps traders gauge how far a price may retrace before continuing the main trend.
                                        </li>
                                        <li>
                                            <strong>Improve Entry and Exit Timing:</strong> Traders can plan entries near retracement levels and exits near the next resistance/support levels.
                                        </li>
                                        <li>
                                            <strong>Assist in Stop-Loss Placement:</strong> Retracement levels act as logical points to place stop-loss orders just beyond them.
                                        </li>
                                        <li>
                                            <strong>Support Confluence Analysis:</strong> When Fibonacci levels align with trendlines or moving averages, it strengthens those price zones.
                                        </li>
                                        <li>
                                            <strong>Visualize Market Psychology:</strong> Fibonacci levels reflect areas where many traders expect reactions, showing collective behavior patterns.
                                        </li>
                                    </ol>


                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        When to Use Fibonacci Retracement Indicator
                                    </h2>

                                    <ol className="list-disc pl-5 space-y-2 text-black">
                                        <li>
                                            <strong>After a Strong Price Move:</strong> Use retracements to find potential levels where price may pull back before resuming trend.
                                        </li>
                                        <li>
                                            <strong>During Trend Continuation Analysis:</strong> When you expect the main trend to continue after a correction.
                                        </li>
                                        <li>
                                            <strong>To Spot Reversal Zones:</strong> Use when looking for possible reversal points during corrective phases.
                                        </li>
                                        <li>
                                            <strong>With Other Indicators:</strong> Combine Fibonacci levels with RSI, MACD, or candlestick patterns to confirm signals.
                                        </li>
                                        <li>
                                            <strong>To Plan Risk-Reward:</strong> Use retracement levels to calculate potential profit targets versus stop-loss distances.
                                        </li>
                                    </ol>

                                    <h2 className="text-2xl font-semibold text-black">
                                        📐 Generate Fibonacci Retracement Levels Using Python
                                    </h2>

                                    <p className="mt-4 text-black leading-relaxed">
                                        You can fetch historical price data from <strong>Yahoo Finance</strong> and
                                        use <strong>Fibonacci Retracement</strong> to identify potential support and resistance levels.
                                        These levels are calculated based on the recent high and low prices, helping traders spot price reversal zones.
                                    </p>

                                    <ul className="list-disc ml-6 mt-3 space-y-2 text-black">
                                        <li>
                                            Fibonacci levels are usually 23.6%, 38.2%, 50%, 61.8%, and 78.6%.
                                        </li>
                                        <li>
                                            When price retraces to one of these levels and reverses, it can act as a <em>support</em> or <em>resistance</em>.
                                        </li>
                                        <li>
                                            Use these levels to plan entry/exit points or set stop losses.
                                        </li>
                                        <li>
                                            Combine Fibonacci with trend indicators like SMA or RSI for better confirmation.
                                        </li>
                                    </ul>


                                </div>

                            </div>
                        )}


                        {language === "hindi" && (
                            <div>
                                <p className="mt-6 text-black leading-relaxed">
                                    फिबोनाची रिट्रेसमेंट एक लोकप्रिय तकनीकी विश्लेषण उपकरण है, जिसका उपयोग
                                    कीमतों के करेक्शन या पुलबैक के दौरान संभावित सपोर्ट और रेज़िस्टेंस स्तरों को
                                    पहचानने के लिए किया जाता है। यह मुख्य फिबोनाची अनुपातों (जैसे 23.6%, 38.2%,
                                    50%, 61.8% और 78.6%) पर आधारित होता है और ट्रेडर्स को यह अनुमान लगाने में
                                    मदद करता है कि कीमत कहां रुक सकती है या पलट सकती है।
                                </p>

                                <div className="w-full">
                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        ट्रेडिंग में फिबोनाची रिट्रेसमेंट का उपयोग कैसे करें
                                    </h2>

                                    <ol className="list-decimal ml-6 mt-4 space-y-4 text-black">
                                        <li>
                                            <strong>अपना ट्रेडिंग प्लेटफ़ॉर्म खोलें:</strong> उस चार्टिंग प्लेटफ़ॉर्म में लॉगिन करें
                                            (जैसे TradingView या Zerodha) जहाँ आप चार्ट पर ड्रॉइंग टूल्स का इस्तेमाल कर सकते हैं।
                                        </li>

                                        <li>
                                            <strong>एक स्पष्ट ट्रेंड चुनें:</strong> किसी मजबूत अपट्रेंड या डाउनट्रेंड की पहचान करें।
                                            फिबोनाची सबसे अच्छा एक बड़े मूव के बाद काम करता है।
                                        </li>

                                        <li>
                                            <strong>फिबोनाची रिट्रेसमेंट टूल चुनें:</strong> चार्ट के ड्रॉइंग टूल्स से
                                            <em>Fibonacci Retracement</em> टूल पर क्लिक करें।
                                        </li>

                                        <li>
                                            <strong>स्विंग लो से स्विंग हाई तक ड्रॉ करें:</strong>
                                            <br />- <strong>अपट्रेंड</strong> में: चार्ट के सबसे नीचे के पॉइंट (स्विंग लो) से ऊपर के पॉइंट (स्विंग हाई) तक खींचें।
                                            <br />- <strong>डाउनट्रेंड</strong> में: ऊपर के पॉइंट (स्विंग हाई) से नीचे के पॉइंट (स्विंग लो) तक खींचें।
                                        </li>

                                        <li>
                                            <strong>मुख्य फिबोनाची स्तर देखें:</strong>
                                            <code>23.6%</code>, <code>38.2%</code>, <code>50%</code>, <code>61.8%</code>,
                                            और <code>78.6%</code> जैसे स्तर अपने-आप दिखाई देंगे।
                                            ये अपट्रेंड में संभावित सपोर्ट और डाउनट्रेंड में संभावित रेज़िस्टेंस जोन होते हैं।
                                        </li>

                                        <li>
                                            <strong>अपना ट्रेड प्लान करें:</strong>
                                            देखें कि कीमत इन स्तरों पर कैसे रिएक्ट करती है:
                                            <br />- अगर कीमत किसी फिबोनाची स्तर से ऊपर उछलती है → वह **सपोर्ट** का काम कर सकता है।
                                            <br />- अगर कीमत किसी फिबोनाची स्तर से नीचे गिरती है → वह **रेज़िस्टेंस** का काम कर सकता है।
                                        </li>

                                        <li>
                                            <strong>अन्य इंडिकेटर्स से पुष्टि करें:</strong> फिबोनाची स्तरों को RSI, MACD या
                                            कैंडलस्टिक पैटर्न जैसे इंडिकेटर्स के साथ मिलाकर सिग्नल की पुष्टि करें।
                                        </li>
                                    </ol>

                                    <ul className="list-disc ml-6 mt-4 space-y-2 text-black">
                                        <li>
                                            <strong>फायदे (Pros):</strong>
                                            <br />- संभावित सपोर्ट और रेज़िस्टेंस जोन पहचानने में मदद करता है।
                                            <br />- ट्रेंड कंटिन्युएशन या रिवर्सल एनालिसिस में उपयोगी।
                                            <br />- अन्य इंडिकेटर्स के साथ मिलाकर मजबूत सिग्नल देता है।
                                            <br />- एंट्री, एग्ज़िट और स्टॉप-लॉस स्तर तय करने में मददगार।
                                        </li>

                                        <li>
                                            <strong>नुकसान (Cons):</strong>
                                            <br />- दिशा नहीं बताता, केवल संभावित स्तर दिखाता है।
                                            <br />- सब्जेक्टिव होता है — कौन-सा हाई/लो पॉइंट चुना जाता है इस पर निर्भर करता है।
                                            <br />- बहुत अधिक वोलाटाइल या न्यूज़-ड्रिवन मार्केट में भरोसेमंद नहीं होता।
                                            <br />- केवल तभी प्रभावी जब अन्य इंडिकेटर्स के साथ उपयोग किया जाए।
                                        </li>
                                    </ul>

                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        फिबोनाची रिट्रेसमेंट वास्तव में क्या कर सकता है
                                    </h2>

                                    <ol className="list-disc pl-5 space-y-2 text-black">
                                        <li>
                                            <strong>सपोर्ट और रेज़िस्टेंस स्तरों की पहचान:</strong> फिबोनाची स्तर बताते हैं कि
                                            किस कीमत पर ट्रेंड रुक सकता है या पलट सकता है।
                                        </li>
                                        <li>
                                            <strong>ट्रेंड में पुलबैक स्तर मापना:</strong> ट्रेडर्स को यह समझने में मदद करता है कि
                                            कीमत कितनी पीछे जा सकती है और फिर मुख्य ट्रेंड में लौट सकती है।
                                        </li>
                                        <li>
                                            <strong>एंट्री और एग्ज़िट टाइमिंग सुधारना:</strong> रिट्रेसमेंट स्तरों के पास एंट्री
                                            और अगली रेज़िस्टेंस/सपोर्ट के पास एग्ज़िट प्लान की जा सकती है।
                                        </li>
                                        <li>
                                            <strong>स्टॉप-लॉस लगाने में मदद:</strong> ये स्तर स्टॉप-लॉस लगाने के लिए तार्किक पॉइंट होते हैं।
                                        </li>
                                        <li>
                                            <strong>कन्फ्लुएंस एनालिसिस सपोर्ट:</strong> जब फिबोनाची स्तर ट्रेंडलाइन या मूविंग
                                            एवरेज के साथ मेल खाते हैं तो वह क्षेत्र और भी मज़बूत हो जाता है।
                                        </li>
                                        <li>
                                            <strong>मार्केट साइकॉलॉजी दिखाना:</strong> फिबोनाची स्तर उन स्थानों को दिखाते हैं
                                            जहाँ ज़्यादातर ट्रेडर्स किसी रिएक्शन की उम्मीद करते हैं।
                                        </li>
                                    </ol>

                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        फिबोनाची रिट्रेसमेंट का उपयोग कब करें
                                    </h2>

                                    <ol className="list-disc pl-5 space-y-2 text-black">
                                        <li>
                                            <strong>किसी बड़े मूव के बाद:</strong> जब कीमत तेज़ी से ऊपर/नीचे गई हो, तब यह देखने के लिए कि वह कहां रुक सकती है।
                                        </li>
                                        <li>
                                            <strong>ट्रेंड कंटिन्युएशन एनालिसिस में:</strong> जब आप उम्मीद करते हैं कि करेक्शन के बाद मुख्य ट्रेंड फिर जारी होगा।
                                        </li>
                                        <li>
                                            <strong>रिवर्सल जोन पहचानने के लिए:</strong> जब आप करेक्टिव फेज़ के दौरान पलटाव पॉइंट ढूंढना चाहते हैं।
                                        </li>
                                        <li>
                                            <strong>अन्य इंडिकेटर्स के साथ:</strong> RSI, MACD या कैंडलस्टिक पैटर्न के साथ मिलाकर गलत सिग्नल कम कर सकते हैं।
                                        </li>
                                        <li>
                                            <strong>रिस्क-रिवार्ड प्लानिंग के लिए:</strong> एंट्री, एग्ज़िट और स्टॉप-लॉस का अनुपात तय करने के लिए।
                                        </li>
                                    </ol>

                                    <h2 className="text-2xl font-semibold text-black">
                                        📐 Python का उपयोग करके Fibonacci Retracement स्तर निकालें
                                    </h2>

                                    <p className="mt-4 text-black leading-relaxed">
                                        आप <strong>Yahoo Finance</strong> से ऐतिहासिक कीमत डेटा ला सकते हैं और
                                        <strong>Fibonacci Retracement</strong> का उपयोग करके संभावित सपोर्ट और रेज़िस्टेंस स्तर
                                        निकाल सकते हैं। ये स्तर हाल के हाई और लो प्राइस पर आधारित होते हैं, जिससे ट्रेडर्स
                                        संभावित रिवर्सल जोन को पहचान सकते हैं।
                                    </p>

                                    <ul className="list-disc ml-6 mt-3 space-y-2 text-black">
                                        <li>आम फिबोनाची स्तर 23.6%, 38.2%, 50%, 61.8% और 78.6% होते हैं।</li>
                                        <li>अगर कीमत इनमें से किसी स्तर तक आती है और फिर पलटती है, तो वह <em>सपोर्ट</em> या <em>रेज़िस्टेंस</em> का काम कर सकता है।</li>
                                        <li>इन स्तरों का उपयोग एंट्री/एग्ज़िट प्लान या स्टॉप-लॉस सेट करने के लिए करें।</li>
                                        <li>बेहतर पुष्टि के लिए फिबोनाची को SMA या RSI जैसे ट्रेंड इंडिकेटर्स के साथ मिलाएं।</li>
                                    </ul>
                                </div>

                            </div>
                        )}
                    </div>

                    {/* Intro Paragraph */}


                </div>

                   <div className="mt-6 w-full  p-4">


                    {/* <pre className="mt-6 bg-gray-900 text-green-300 p-4 rounded-lg overflow-x-auto text-sm"> */}
                      <pre className="mt-6 bg-gray-900 text-green-300 p-4 rounded-lg overflow-x-auto text-sm sm:text-xs md:text-sm">

                        <code>{`
import yfinance as yf
import pandas as pd
import matplotlib.pyplot as plt

# Fetch historical data for a stock (e.g., Reliance)
ticker = "RELIANCE.NS"
data = yf.download(ticker, start="2024-08-01", end="2024-09-01", interval="1d")

# Find recent high and low
high = data['High'].max()
low = data['Low'].min()

# Calculate Fibonacci levels
diff = high - low
levels = {
    '23.6%': high - 0.236 * diff,
    '38.2%': high - 0.382 * diff,
    '50%': high - 0.5 * diff,
    '61.8%': high - 0.618 * diff,
    '78.6%': high - 0.786 * diff
}

# Plot closing price and Fib levels
plt.figure(figsize=(10,6))
plt.plot(data['Close'], label='Close Price', color='blue')
for level, price in levels.items():
    plt.axhline(price, linestyle='--', label=level)
plt.title('Fibonacci Retracement Levels')
plt.xlabel('Date')
plt.ylabel('Price')
plt.legend()
plt.show()
`}</code>
                    </pre>

                    {/* Pros and Cons Section */}

                </div>


            </div>
            <Footer></Footer>
        </div>

    );

}

export default FibonacciRetracement